export const SITE_NAME = 'FIFA';
export const {REACT_APP_BASE_API_PATH} = process.env;